module.exports = __webpack_public_path__ + "onboarding-accounts.bb5c6962b1b64f5a4818ad92aa4ea4cd.hashedasset.svg";